import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import {Trash2} from "react-feather";
import NewWorkDoneAuftraggeber from "./NewWorkDoneAuftraggeber";
import {getToken} from "../../Utils/Common";
import moment from "moment";
import Select from "react-select";
//import Select from 'react-select'

//import Select from "react-dropdown-select";

//import Select from 'react-select'


function WorkDone(props) {

    let [disable, setdisable] = useState(false)


    let [agData, setAGData] = React.useState(props.auftraggeberData)
    let [projectIDData, setprojectIDData] = React.useState([])
    //let [anmeldungDate,setAnmeldungDate]=useState(props.auftraggeberData?props.auftraggeberData[0].registerDate
    //   :moment().format("YYYY-MM-DD"))
    let [doneanmeldungDate, setDoneAnmeldungDate] = useState(props.donerDate ?? null)
    let [donefreigabeDate, setDoneFreigabeDate] = useState(props.donecDate ?? null)

    //let [freigabeDate,setFreigabeDate]=React.useState(props.auftraggeberData?props.auftraggeberData[0].confirmationDate
    //   :moment().format("YYYY-MM-DD"))

    //let [freigabeType,setFreigabeType]=React.useState({label: '', value: ''})

    let [options] = React.useState([{label: 'Email', value: 'Email'}, {label: 'Fax', value: 'Fax'},
        {label: 'Brief', value: 'Brief'}, {label: 'Einschreiben', value: 'Einschreiben'}, {label: 'App', value: 'App'}])
    let [donefreigabeType, setDoneFreigabeType] = React.useState({label: '', value: ''})


    useEffect(async () => {
        if (props.registerationdata !== undefined) {
            setdisable(props.registerationdata[0].entscheidungsbefugnis &&
                props.registerationdata[0].pre_signurl !== "")
        }
        setAGData(props.auftraggeberData)
        if (props.auftraggeberData !== undefined) {

            //setAnmeldungDate(moment(props.auftraggeberData[0].registerDate).format("YYYY-MM-DD"))
            //setFreigabeDate(moment(props.auftraggeberData[0].confirmationDate).format("YYYY-MM-DD"))
            setDoneAnmeldungDate(moment(props.donerDate).format("YYYY-MM-DD"))
            setDoneFreigabeDate(moment(props.donecDate).format("YYYY-MM-DD"))
        } else {
            setDoneAnmeldungDate(moment(null).format("YYYY-MM-DD"))
            setDoneFreigabeDate(moment(null).format("YYYY-MM-DD"))
        }

        /*setAnmeldungDate(props.auftraggeberData?moment(props.auftraggeberData[0].registerDate).format("YYYY-MM-DD")
            :moment().format("yyyy-MM-dd"))
        setFreigabeDate(props.auftraggeberData?moment(props.auftraggeberData[0].confirmationDate).format("YYYY-MM-DD")
            :moment().format("yyyy-MM-dd"))*/

        await fetchAG().then(agData => {
            agData.data.filter(function (item) {
                return item.entscheidungsbefugnis === true
            })
            let result = agData.data.filter((word) => word.entscheidungsbefugnis === true);
            setprojectIDData(result)
        })
        /*setFreigabeType({value:props.auftraggeberData?props.auftraggeberData[0].confirmationType:"Email",
            label:props.auftraggeberData?props.auftraggeberData[0].confirmationType:"Email"})*/
        setDoneFreigabeType({value: props.donetValue, label: props.donetValue})
        console.log(agData)
    }, [props.auftraggeberData, props.donerDate, props.donecDate, props.donetValue]);

    async function fetchAG() {

        let apiBody = {
            "token": getToken(), "data": {
                "projectID": props.pID
            }
        }

        return await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/auftraggeberList", {
            method: 'POST', headers: {
                'Content-type': 'application/json',
            }, body: JSON.stringify(apiBody),
        })
            .then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })
    }

    function getWorkDoneAuftraggeberTableBody(auftraggeberData) {
        console.log(auftraggeberData, 235252452)
        return auftraggeberData?.map((item) => (<tr key={item.id}>
            <td>{item.firstName}</td>
            <td>{item.lastName}</td>
            <td>{item.role}</td>

            {/*<td>{item.entscheidungsbefugnis}</td>*/}
            <td
                style={{
                    display: props.originState ? "none" : "table-cell", textAlign: "center", verticalAlign: "middle",
                }}
            >
                <button className="btn btn-danger"
                        disabled={disable}
                        onClick={() => deleteAuftraggeber(item.id)}
                >
                    <Trash2/>
                </button>
            </td>
        </tr>))
    }


    /*const deleteAuftraggeber = (auftraggeber) => {

        props.setIsChange(false)
        let newAuftraggeberData = props.auftraggeberData.filter((item) => item.id !== id);
        setAGData(newAuftraggeberData);
        while (props.auftraggeberData.length > 0) {
            props.auftraggeberData.pop();
        }
        newAuftraggeberData.map((item) => {
            props.auftraggeberData.length = 0
            props.auftraggeberData.push(item);
            let newState = props.stundenReportData
            newState.auftraggeber_done = props.auftraggeberData
            props.setStundenReportData(newState)
        });
    }*/

    const deleteAuftraggeber = (id) => {

        props.setIsChange(false)
        let newAuftraggeberData = props.auftraggeberData.filter((item) => item.id !== id);
        setAGData(newAuftraggeberData);
        while (props.auftraggeberData.length > 0) {
            props.auftraggeberData.pop();
        }
        newAuftraggeberData.map((item) => {
            props.auftraggeberData.length = 0
            props.auftraggeberData.push(item);
            let newState = props.stundenReportData
            newState.auftraggeber_done = props.auftraggeberData
            props.setStundenReportData(newState)
        });
    }

    return (<>


        <NewWorkDoneAuftraggeber
            disable={disable}
            projectID={props.pID}
            originState={props.originState}
            auftraggeberReportData={props.auftraggeberData}
            setAuftraggeberReportData={setAGData}
            projectIDData={projectIDData}
            setIsChange={props.setIsChange}
        />
        <br/>


        <Row>


            <Col sm={6}>

                <table className="table handwai-white-text">
                    <thead>
                    <tr>
                        <th scope="col">Vorname</th>
                        <th scope="col">Nachname</th>
                        <th scope="col">Rolle</th>
                        {/*<th scope="col">Entscheidungsbefugt</th>*/}
                        <th scope="col" style={{display: props.originState ? "none" : "table-cell"}}>Löschen</th>
                    </tr>
                    </thead>
                    <tbody>

                    {getWorkDoneAuftraggeberTableBody(props.auftraggeberData)}

                    </tbody>
                </table>

            </Col>

            <Col sm={6}>
                <Row>

                    <label className="handwai-text-label-normal"> Abmeldung Versendet </label>
                    &nbsp;&nbsp;<input type="date"
                                       disabled={props.originState}
                                       value={doneanmeldungDate}
                                       onChange={(e) => {
                                           setDoneAnmeldungDate(e.target.value)
                                           props.setDoneRDate(e.target.value)
                                       }}
                /> &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;

                    &nbsp; &nbsp;&nbsp;

                    <label className="handwai-text-label-normal"> Bestätigungsdatum </label>
                    &nbsp;&nbsp;
                    <input type="date"
                           disabled={props.originState}
                           value={donefreigabeDate}
                           onChange={(e) => {
                               setDoneFreigabeDate(e.target.value)
                               props.setDoneCDate(e.target.value)
                           }
                           }/>
                    &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;


                    <label className="handwai-text-label-normal"> Bestätigungs per </label>
                    &nbsp;&nbsp;
                    <Select
                        placeholder={"Type auswählen:"}
                        options={options}
                        value={donefreigabeType}
                        onChange={newValue => {
                            setDoneFreigabeType(newValue)
                            props.setDoneTValue(newValue.label)
                        }}

                    />


                </Row>
                {/*<Row>

                    <label className="handwai-text-label-normal"> Anmeldung Versendet </label>
                    &nbsp;&nbsp;<input type="date"
                                       disabled={props.originState}
                                       value={anmeldungDate}
                                       onChange={(e) => {
                                           setAnmeldungDate(e.value)
                                           let newState = props.stundenReportData
                                           console.log(props.stundenReportData, 66666)
                                           if (newState.auftraggeber_confirmation.length === 0) {
                                               let f = {"registerDate": ""}
                                               newState.auftraggeber_confirmation.push(f)
                                           }
                                           newState.auftraggeber_confirmation[0].registerDate = e.target.value
                                           props.setStundenReportData(newState)
                                       }
                                       }
                /> &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;

                    &nbsp; &nbsp;&nbsp;

                    <label className="handwai-text-label-normal"> Freigabe Erhalten am </label>
                    &nbsp;&nbsp;
                    <input type="date"
                           disabled={props.originState}
                           value={freigabeDate}
                           onChange={(e) => {
                               setFreigabeDate(e.target.value)
                               let newState = props.stundenReportData
                               if (newState.auftraggeber_confirmation.length === 0) {
                                   let f = {"confirmationDate": ""}
                                   newState.auftraggeber_confirmation.push(f)
                               }
                               newState.auftraggeber_confirmation[0].confirmationDate = e.target.value
                               props.setStundenReportData(newState)
                           }
                           }/>
                    &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;


                    <label className="handwai-text-label-normal"> Freigabe Erhalten per </label>
                    &nbsp;&nbsp;
                    <Select
                        placeholder={"Type auswählen:"}
                        options={options}
                        value={freigabeType}
                        onChange={newValue => {
                            let newState = props.stundenReportData
                            if (newState.auftraggeber_confirmation.length === 0) {
                                let f = {"confirmationType": ""}
                                newState.auftraggeber_confirmation.push(f)
                            }
                            newState.auftraggeber_confirmation[0].confirmationType = newValue.value
                            props.setStundenReportData(newState)
                            setFreigabeType(newValue)
                        }}

                    />


                </Row>*/}
                <br/><br/>


            </Col>


        </Row>

    </>);
}

export default WorkDone;
